import type { Doc } from "building-types/doc";
import type { SystemParameterHandle } from "building-types/handles/docEntityHandleTypes";
import type { SystemParameter } from "building-types/options/parameter";
import { systemParametersFromDoc } from "../systemParameterTools";

export function docGetSystemParameter(
  doc: Pick<Doc, "optionSets" | "optionChoices" | "attributes">,
  handle: SystemParameterHandle,
): SystemParameter | undefined {
  const { systemParameters } = systemParametersFromDoc(doc);
  const parameter = systemParameters[handle.id];

  if (!parameter) {
    return undefined;
  }

  return parameter;
}
